module.exports = __webpack_public_path__ + "img/banker-line.a5ae8a63.svg";